import React, {useEffect, useState} from 'react';
import {Link} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import {Dropdown} from '@components';
import * as mainService from "@app/services/mainService";
import {myService} from "@app/services/hopthuService";
import {alertService} from "@app/services/alertService";
import {formatDateClient} from "@app/utils/CommonFunctions";
import ReactTimeAgo from "react-time-ago";

const NotificationsDropdown = () => {
    const [t] = useTranslation();
    const [totalitem,setTotalitem] = useState(0);
    const [danhSachHopThu,setDanhSachHopThu] = useState([]);
    useEffect(async () => {
       /* myService
            .getAll(1, 111111, {isRead:0})
            .then((d) => {

                //console.log('retrieveTutorials.....');
                console.log(d);
                const { danhSachHopThu, pageinfo } = d;
              //  setObjs(danhSachHopThu);
                setDanhSachHopThu(danhSachHopThu);
                setTotalitem(pageinfo.totalitem);
            })
            .catch(alertService.error);*/
    }, []);

    return (
        <Dropdown
            isOpen={false}
            size="lg"
            buttonTemplate={
                <>
                    <i className="far fa-bell" />
                    <span className="badge badge-warning navbar-badge">{totalitem}</span>
                </>
            }
            menuTemplate={
                <>
                    <span className="dropdown-item dropdown-header">
                        {t('header.notifications.count', {quantity: totalitem})}
                    </span>
                    <div className="dropdown-divider" />

                    {danhSachHopThu.map((item, i) => {

                        return (
                            item && (
                                <div>
                                    <Link to={ "/ThongBaoNhan/view/" + item.id } className="dropdown-item">

                                        <i className="fas fa-envelope mr-2" />
                                        <span >
                                            { item.nguoigui}
                                            <p>{item.title}</p>
                                        </span>
                                        <span className="float-right text-muted text-sm">
                                            <ReactTimeAgo date={new Date(item.ngaychot)} locale="en-US"/>
                                        </span>
                                    </Link>

                                    <div className="dropdown-divider" />
                                </div>


                            )
                        );
                    })}


                    <div className="dropdown-divider" />
                    <Link to="/ThongBaoNhan" className="dropdown-item dropdown-footer">
                        {t('header.notifications.seeAll')}
                    </Link>
                </>
            }
        />
    );
};

export default NotificationsDropdown;
